import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { CardStyleInterpolators } from "@react-navigation/stack";
import { View } from "react-native-ui-lib";
import { ModalCloseButton } from "@towersystems/roam-common-native";
import {
  StockCountCompletedRootParamList,
  StockCountsRootParamList,
} from "../../../../types";
import { createStackHeaderNavigator } from "@towersystems/roam-common-native";
import { StockCountCompletedContext } from "../../utils/stocktake-completed/context";
import { StockCountCompletedScreen } from "../StockCountCompletedScreen";
import {
  useQueryStockCount,
  useQueryStockCountLines,
} from "../../../../utilities/stock-count/hooks";
import { StockCountCompletedCountHistoryScreen } from "../StockCountCompletedCountHistoryScreen";

export type StockCountCompletedRootScreenProps = NativeStackScreenProps<
  StockCountsRootParamList,
  "StockCountCompletedRootScreen"
> & {};

export const StockCountCompletedRootScreen = ({
  route,
}: StockCountCompletedRootScreenProps) => {
  const RootNavigator =
    createStackHeaderNavigator<StockCountCompletedRootParamList>();

  const stockCountId = route.params.stockCountId;

  const { stockCount } = useQueryStockCount({ stockCountId });
  const { stockCountLines } = useQueryStockCountLines({ stockCountId });

  if (!stockCount || !stockCountLines) {
    return <View />;
  }

  return (
    <StockCountCompletedContext.Provider
      value={{ stockCount, stockCountLines }}
    >
      <RootNavigator.Navigator>
        <RootNavigator.Group
          screenOptions={{
            animationEnabled: true,
            headerTitleAlign: "center",
            title: "",
            headerLeft: () => <ModalCloseButton type="Back" />,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <RootNavigator.Screen
            name="StockCountCompletedScreen"
            component={StockCountCompletedScreen}
          />

          <RootNavigator.Screen
            name="StockCountCompletedCountHistoryScreen"
            component={StockCountCompletedCountHistoryScreen}
          />
        </RootNavigator.Group>
      </RootNavigator.Navigator>
    </StockCountCompletedContext.Provider>
  );
};
